export default "__VITE_ASSET__jOeKz6Ov__"